// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3ZIPP){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_OeMx7 .dualColumn_3qg5c{display:flex;align-content:space-between}.nsAddressForm_OeMx7 .dualColumn_3qg5c .firstCol_3XVGG{margin-right:20px}.optional_2MFbk{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3ZIPP",
	"nsAddressForm": "nsAddressForm_OeMx7",
	"dualColumn": "dualColumn_3qg5c",
	"firstCol": "firstCol_3XVGG",
	"optional": "optional_2MFbk"
};
module.exports = exports;
